import { supportedLocales } from "../../package.json";
export const SUPPORTED_LOCALES = [...supportedLocales] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: SupportedLocale = "en-GB";
